import { ModuleWithProviders, NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { EffectsModule } from "@ngrx/effects";
import { StoreModule } from "@ngrx/store";
import { CookieModule } from "ngx-cookie";
import { AccountEffects } from "./+state/effects";
import Facades from "./+state/facades";
import { AccountConfig, ACCOUNT_CONFIG } from "./+state/providers";
import { ACCOUNT_FEATURE_KEY, accountReducer } from "./+state/reducers";
import { AccountService } from "./+state/services";

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(ACCOUNT_FEATURE_KEY, accountReducer),
    EffectsModule.forFeature([AccountEffects]),
    CookieModule.forRoot()
  ],
  providers: [Facades, AccountService]
})
export class AccountDataAccessModule {
  static forRoot(
    accountConfig: AccountConfig
  ): ModuleWithProviders<AccountDataAccessModule> {
    return {
      ngModule: AccountDataAccessModule,
      providers: [
        {
          provide: ACCOUNT_CONFIG,
          useValue: accountConfig
        }
      ]
    };
  }
}
